import React from 'react';
const TabDropdown = (props) => {
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    const strokeColor = props.stroke || 'white';
    return (React.createElement("svg", Object.assign({ width: "10", height: "6", viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M9 1L5 5L1 1", stroke: strokeColor, strokeWidth: "1.2", strokeLinejoin: "round" })));
};
export default TabDropdown;
